import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ChartRadar"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M12 1.5L1.5 9.75L6 22.5H18L22.5 9.75L12 1.5ZM13.9363 15.9488L9.44678 16.9468L8.37983 11.0779L12.0623 7.92112L16.1435 10.9823L13.9363 15.9488ZM14.0846 17.4529L15.9948 21H8.0052L9.3486 18.505L14.0846 17.4529ZM7.1925 10.1203L4.305 9.45375L11.25 3.99683V6.64268L7.1925 10.1203ZM12.75 6.5625V3.99683L19.695 9.45375L17.3325 9.999L12.75 6.5625ZM3.46072 10.7984L6.95085 11.6038L8.06415 17.7268L6.76065 20.1479L3.46072 10.7984ZM17.2393 20.1479L15.3069 16.559L17.5616 11.4855L20.5391 10.7984L17.2393 20.1479Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ChartRadar.vue"]]);
